import RuleProvider from "diagram-js/lib/features/rules/RuleProvider";

import inherits from "inherits";

export default function CustomRules(eventBus) {
  RuleProvider.call(this, eventBus);

  this.addRule("elements.delete", function (context) {
    // don't allow deleting script tasks
    return context.elements.filter(function (e) {
      if (e.componentName === "Scheduler") {
        return !e.businessObject.$instanceOf("bpmn:Task");
      } else {
        return e.businessObject.$instanceOf("bpmn:Task");
      }
    });
  });
}

inherits(CustomRules, RuleProvider);

CustomRules.$inject = ["eventBus"];
